import { Storybook } from "@tento-ui/ui/storybook";

import { ThreadFixture } from "../thread/fixture";
import { TERMINAL_SKIN } from "./skin";

/**
 * The terminal skin's `kv-grid` slot — a property list, aligned.
 *
 * The props come from `ThreadFixture.TURN`, the one hand-authored session the
 * contract is proved against, filtered to this slot. Mounting them through
 * `TERMINAL_SKIN.make` is the same call `ThreadFixture.renderWith` makes, so
 * this card cannot drift from the session: a case that renders here renders
 * there, and a slot the session stops covering stops having a card.
 */
export class TermTurnKvGridStoryBook extends Storybook.Default {
  title(): string {
    return "Terminal skin — kv-grid";
  }

  examples(): Storybook.Example[] {
    const rows = ThreadFixture.TURN.filter((entry) => entry.slot === "kv-grid");
    return rows.map((entry, index) => ({
      title: rows.length > 1 ? `case ${index + 1}` : "From the session",
      render: () => TERMINAL_SKIN.make(entry.slot, entry.props),
    }));
  }
}
